import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { SmallHeadline } from 'components/Typography'
import { GreenTag, RedTag } from 'components/Tag'
import { SmallLabel } from 'components/Label'

type Props = {
  breadName: string
  imageUrl: string
  hasStocks: boolean
}

const ScheduleCardReadonly: FC<Props> = (props) => {
  const { breadName, imageUrl, hasStocks } = props

  return (
    <div className={styles.row__inner}>
      <FlexRow justifyContent={'start'}>
        <div className={styles.row__image}>
          <img src={imageUrl} alt={breadName} />
        </div>
        <Spacer size={12} />
        <div className={styles.row__body}>
          <SmallHeadline label={breadName} />
          <Spacer size={8} />
          <FlexRow justifyContent={'start'}>
            <SmallLabel label={'現在の設定：'} />
            <Spacer size={2} />
            {hasStocks ? (
              <GreenTag shape={'ellipse'} startIcon={'/icon/white/circle.svg'} tagName={'受付中'} />
            ) : (
              <RedTag shape={'ellipse'} startIcon={'/icon/white/close.svg'} tagName={'未設定'} />
            )}
          </FlexRow>
        </div>
      </FlexRow>
    </div>
  )
}

export default ScheduleCardReadonly
